import { Instant } from "@js-joda/core";
import { API } from "../API";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import {
  VisitInstanceId,
  PlanOfCareItemId,
  PatientDocumentCreateAnswer,
  PatientDocumentTypeId,
} from "../messages";

export default function useDutySheet(params: {
  postPatientDocAnswer: API["postPatientDocAnswer"];
  visitInstanceId: VisitInstanceId;
}) {
  const dutySheetDocument = PatientDocumentTypeId.wrap(-12345);
  const queryClient = useQueryClient();

  const checkTaskMutation = useMutation({
    mutationFn: (answer: PatientDocumentCreateAnswer) =>
      params.postPatientDocAnswer(params.visitInstanceId, dutySheetDocument, {
        answer: answer.answer,
        chartRow: -1,
        questionId: Number.parseInt(answer.questionId.toString(), 10),
        createdAt: Instant.now(),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["visit_instance", params.visitInstanceId]);
    },
  });

  const updateDutySheetTask = async (taskId: PlanOfCareItemId, isChecked: boolean) => {
    checkTaskMutation.mutate({
      answer: isChecked ? ["Done"] : [],
      chartRow: -1,
      questionId: Number.parseInt(taskId.toString(), 10),
      createdAt: Instant.now(),
    });
  };

  const updateDutySheetTaskNotes = async (taskId: PlanOfCareItemId, notes: string) => {
    checkTaskMutation.mutate({
      answer: notes,
      chartRow: -1,
      questionId: Number.parseInt(taskId.toString(), 10) + 1000,
      createdAt: Instant.now(),
    });
  };
  return {
    updateDutySheetTaskNotes,
    updateDutySheetTask,
  };
}
